export const api = {

    /* COMMON APIS */
    _permissionsAuth: 'admin/v1/admin/adminPermissions',
    _signedURL: 'admin/v1/common/getSignedURL',
    _agencyLists: 'api/admin/form/agency-list',

    /* LOGIN FLOW APIS*/
    _adminLogin: 'api/admin/auth/login',
    _requestOtp: 'api/admin/auth/request-otp',
    _verifyOtp: 'api/admin/auth/verify-otp',
    _logoOut: 'api/admin/auth/logout ',

    // Form builder 
    _getFormsList: 'api/admin/form/list',
    _viewFormTemplate: 'api/admin/form/view',
    _getCurrentForms: 'api/admin/form/fields',
    _editFormField: 'api/admin/form/field/edit',
    _resetToDefaultFormField: 'api/admin/form/field/reset',
    _dragDrop: 'api/admin/form/field/row-swap',

}